import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=5b91b5f4&scoped=true&"
import script from "./exam.vue?vue&type=script&lang=js&"
export * from "./exam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91b5f4",
  null
  
)

export default component.exports